import { render, staticRenderFns } from "./addPoint.vue?vue&type=template&id=deb3488c&"
import script from "./addPoint.vue?vue&type=script&lang=js&"
export * from "./addPoint.vue?vue&type=script&lang=js&"
import style0 from "./addPoint.vue?vue&type=style&index=0&id=deb3488c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports